import { cn } from '@/lib/utils';

type Props = {
    children: React.ReactNode;
    className?: string;
    contentClassName?: string;
};

export default function FcPageFrame({ children, className, contentClassName }: Props) {
    return (
        <div className={cn('fc-page-frame', className)}>
            <div className={cn('fc-page-scroll', contentClassName)}>{children}</div>
        </div>
    );
}
